import { TextWithTooltip } from '@v2/components/controls/TextWithTootip/TextWithTooltip';
import classes from 'classnames';
import React, { PropsWithChildren } from 'react';
import { useStyles } from './PropertyEdit.styles';

interface PropertyEditProps extends PropsWithChildren {
  label: string;
  tooltip: string;
  className?: string;
}

export const PropertyEdit: React.FC<PropertyEditProps> = ({ tooltip, label, children, className }) => {
  const styles = useStyles();

  return (
    <div className={classes(styles.propertyRow, className)}>
      <TextWithTooltip tooltip={tooltip} text={label} />
      <div>{children}</div>
    </div>
  );
}
